﻿window.cTable = function (bddRef) {

    var lstNomTable  = null
    this.mGetLstNomTable = function () {
        if (lstNomTable == null) {
            lstNomTable = []
            bddRef.vue_table.forEach(function (tab) { lstNomTable.push(tab.nom) })
        }
        return lstNomTable
    }
    bddRef.vue_table.forEach(function (tab) {
        switch (tab.nom) {
            case "histo_consult":
                tab.libelle = "Consultation";
                tab.show_corbeille = false
                break;
            case "planiti":
                tab.libelle = "Planiti";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasPlaniti()
                break;
            case "planiti_reunion":
                tab.libelle = "Réunion planiti";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasPlaniti()
                break;
            case "filtre":
                tab.libelle = "Filtre";
                tab.show_corbeille = true
                break;
            case "com_email_recu":
                tab.libelle = "Email reçu";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasEmail() && bddRef.baseAppli.para.email.has_reception_email
                break;
            case "com_email_envoi":
                tab.libelle = "Email envoyé/brouillon";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasEmail()
                break;
            case "doc_cpt":
                tab.libelle = "Document comptable";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasDocCpt()
                break;
            case "com_courrier":
                tab.libelle = "courrier";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasCourrier()
                break;
            case "com_sms_envoi":
                tab.libelle = "SMS";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasSms()
                break;
            case "structures":
                tab.libelle = "Structure";
                tab.show_corbeille = true
                break;
            case "structures_contact":
                tab.libelle = "Structure/contact";
                tab.show_corbeille = true
                break;
            case "contact":
                tab.libelle = "Contact";
                tab.show_corbeille = true
                break;
            case "agenda":
                tab.libelle = "Agenda";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasAgenda()
                break;
            case "pipeline":
                tab.libelle = "Pipeline";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasPipeline()
                break;
            case "champ_table":
                tab.libelle = "Champ personnalisé";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasPersoChamp()
                break;
            case "com_note":
                tab.libelle = "Note";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasNote()
                break;
            case "com_rdv":
                tab.libelle = "Rendez-vous";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasAgenda()
                break;
            case "compte_email":
                tab.libelle = "Compte email";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasEmail()
                break;
            case "Dossier":
                tab.libelle = "Dossier";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasDossier()
                break;
            case "Classeur":
                tab.libelle = "Classeur";
                tab.show_corbeille = true
                break;
            case "projet":
                tab.libelle = "Projet";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasProjet()
                break;
            case "rappel":
                tab.libelle = "Rappel";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasAgenda()
                break;
            case "fichier_table":
                tab.libelle = "Fichier";
                break;
            case "bc_dossier":
                tab.libelle = "Dossier base de connaissance";
                break;
            case "bc_article":
                tab.libelle = "Article base de connaissance";
                break;
            case "com_email_envoi_tracking_vue":
                tab.libelle = "Tracking vue email";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasEmail()
                break;
            case "com_email_envoi_tracking_click":
                tab.libelle = "Tracking click email";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasEmail()
                break;
            case "com_sms_envoi_tracking_vue":
                tab.libelle = "Tracking vue SMS";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasSms()
                break;
            case "com_sms_envoi_tracking_click":
                tab.libelle = "Tracking click SMS";
                tab.show_corbeille = bddRef.objCptCli.objetMetier.hasSms()
                break;
            default: tab.libelle = tab.nom.replace("_", " "); break;
        }
    })

    this.mGetItemFromNom = function (nomTable) {
        if (nomTable == "fichier") {
            return {
                id_table: 0,
                nom: "fichier"
            }
        } else if (nomTable == "log") {
            return {
                id_table: 9999,
                nom: "log"
            }
        } else {
            if (typeof tableNom[nomTable] == 'undefined') {
                tableNom[nomTable] = bddRef.vue_table.filter(function (table) { return table.nom == nomTable })[0];
            }
            return tableNom[nomTable]
        }

    }

    var tableNom = {}
    this.mGetItem = function (idTable) {
        if (idTable == "0") {
            return {
                nom: "fichier",
                id: 0
            }
        } else if (idTable == "9999") {
            return {
                nom: "log",
                id: 9999
            }
        } else {
            //var result = null;
            if (typeof tableNom["table_" + idTable] == 'undefined') {
                tableNom["table_" + idTable] = bddRef.vue_table.filter(function (o) { return o.id_table == idTable })[0]
            }
            return tableNom["table_" + idTable]
        }
    }

    this.mGetIdTable = function (nomTable) {
        var result = this.mGetItemFromNom(nomTable);
        if (result == null) { return null } else { return result.id_table }
    }

    this.mGetDescriptionFromNom = function (nomTable) {
        var tab = this.mGetItemFromNom(nomTable)
        if (tab.description && tab.description.length > 0) { return tab.description }
        else { return tab.nom }
    }

    this.mGetDescription = function (idTable) {
        var tab = this.mGetItem(idTable)
        if (tab.description && tab.description.length > 0) { return tab.description }
        else { return tab.nom }
    }

    this.mGetDescriptionFormat = function (idTable) {
        return this.mGetDescription(idTable).substring(0, 1).toUpperCase() + this.mGetDescription(idTable).substring(1)
    }

    this.mGetLstColonne = function (idTable) {
        var lstColonne = []
        bddRef.vue_colonne.forEach(function (colonne) { if (colonne.id_table == idTable) lstColonne.push(colonne); });
        return lstColonne
    }

    var lstDataTableInCorbeille = null;
    this.mGetLstDataTableInCorbeille = function () {
        if (lstDataTableInCorbeille == null) {
            lstDataTableInCorbeille = []
            bddRef.vue_table.forEach(function (dataTable) {
                if (dataTable.is_displayed_in_corbeille == "1") lstDataTableInCorbeille.push(dataTable)
            })
        }
        return lstDataTableInCorbeille
    }

    this.mGetAlignementInGridAwsm = function (idTable) {
        switch (this.mGetItem(idTable).nom) {
            case "com_email_envoi": return "right"; break;
            default: return "left"; break;
        }
    }

    this.mGetLookUpForFilterBuilderStrCon = function () {
        var lst = [{
            nom: "Structure",
            id: bddRef.table.mGetItemFromNom("structures").id_table
        }, {
            nom: "Contact",
            id: bddRef.table.mGetItemFromNom("contact").id_table
        }, {
            nom: "structure/contact",
            id: bddRef.table.mGetItemFromNom("structures_contact").id_table
        }]
        if (bddRef.nom_base.endsWith("_aagest")) {
            lst.push({
                nom: "Compte client",
                id: bddRef.table.mGetItemFromNom("compte_client").id_table
            })
            lst.push({
                nom: "Compte client utilisateur",
                id: bddRef.table.mGetItemFromNom("compte_client_utilisateur").id_table
            })
        }
        return {
            dataSource: lst,
            displayExpr: "nom",
            valueExpr: "id",
            placeholder: "Sélectionner les types d'éléments"
        }
    }

}